import { prechargeTranslations } from "./precharge-pt-br";

export const precharge_FR_FR: prechargeTranslations = {
	addNewPrecharge: {
		aliases: "Alias",
		beginAt: "Commence à",
		bonus: "Bonus",
		childFriendly: "Convient aux enfants",
		cover: "Couverture",
		darkMode: "Mode obscur",
		endsAt: "Finit à",
		eventName: "Nom de l'événement",
		expirationDate: "Date d'expiration des rechargements",
		logo: "Logo",
		mainImage: "Image principale",
		minimumValue: "Montant minimum",
		operationConfig: "Paramètres Opération",
		preSetedValues: "Valeurs présélectionnées",
		prechargeOperation: "Opérations de préchargement",
		primaryColor: "Couleur primaire",
		rechargeConfig: "Paramètres de rechargement",
		rechargeDuration: "Durée du rechargement",
		siteAppearance: "Apparence du site",
		siteConfig: "Paramètre du site",
		slug: "Slug",
		termsOfService: "Conditions d'utilisation",
		ticketUrl: "URL du billet",
		validRechargDate: "Les rechargements sont valables du",
	},
	card: {
		noEnd: "Aucune fin",
		noTermsOfService: "Pas de conditions d'utilisation",
	},
	createNewPrecharge: "Créer une opération de préchargement",
	empty: "Aucune opération de préchargement n'est enregistrée",
	noSearchResults: "La recherche n'a donné aucun résultat",
	searchPlaceholder: "Rechercher par nom d'opération de préchargement",
	sideTab: {
		beginAt: "Commence à",
		childFriendly: "Convient aux enfants",
		darkMode: "Mode obscur",
		durability: "Durée du rechargement",
		edit: "Modifier l'opération de préchargement",
		endsAt: "Finit dans",
		expiresAt: "Date d'expiration des rechargements",
		preChargeOperation: "Opération de préchargement",
		primaryColor: "Couleur primaire",
		remove: {
			button: "Supprimer l'opération de précharge",
			title: "Êtes-vous sûr de vouloir supprimer cette opération de préchargement ?",
		},
		slug: "SLUG",
		undefined: "Non défini",
		validRecharges: "Les rechargements sont valables du",
		withoutTerms: "Pas de conditions d'utilisation",
	},
	title: "Opérations de préchargement",
	prechargeStore: {
		createPrechargeOperationSuccess: "Opération de préchargement créée avec succès",
		updatePrechargeOperationSuccess: "Opération de préchargement mise à jour avec succès",
		deletePrechargeOperationSuccess: "Opération de préchargement supprimée avec succès",
	},
	homePage: {
		deleteTitle: "Supprimer le site de préchargement",
		deleteSubtitle: "Êtes-vous sûr de vouloir supprimer ce site Preload?",
		title: "Pré-Charge",
		description:
			"Créer un site Web permettant aux clients de pré-charger avant le début de l'événement, en évitant les files d'attente et en réduisant par conséquent le volume des opérations lors de l'événement.",
		createButton: "Créer un site de préchargement",
		searchInputPlaceholder: "Rechercher un site",
		willExpire: "Expire dans",
		hasExpired: "Expiré dans",
		copyLink: "Copier le lien vers le site Web",
		active: "Actif",
		inactive: "Inactif",
		expired: "Expiré",
		copied: "Lien copié.",
		report: "Rapport",
	},
	formPage: {
		title: "Nouveau site Web Pre-Charge",
		description:
			"Remplissez les données et faites la promotion du site Web auprès de vos clients. Permettez aux utilisateurs de précharger avant le début de l'événement, évitant ainsi les files d'attente et réduisant le volume d'opérations lors de l'événement.",
		nextStep: "Étape suivante",
		discard: "Annuler la création",
		logoDescription: "L'image doit être au format .jpeg ou .png, avec 880px par 880px",
		siteSettingsTitle: "Paramètres du site",
		rechargeSettingsTitle: "Paramètres de precharge",
		tipsTitle: "Conseils sur l'événement",
		eventData: {
			title: "Informations sur l'événement",
			logo: "Logo de l'événement",
			eventName: "Nom de l'événement",
			eventNamePlaceholder: "Entrez le nom de l'événement",
			email: "Email de contact",
		},
		customization: {
			title: "Personnalisation du site Web",
			slug: "URL du site Web",
			slugPlaceholder: "Tapez le nom de l'événement",
			color: "Couleur des détails",
			rechargesPeriod: "Couleur des détails",
			endsAt: "Supprimer le site",
			buffer: "Photo en vedette sur la page",
			mainPageInfoTitle: "Titre de la page d'accueil",
			mainPageInfoTitleDescription:
				"Suggestion : Peecharge? '{{name}}' a ! Planifiez à l'avance et évitez les files d'attente",
			mainPageInfoTitlePlaceholder:
				"Tapez ici le titre que vous souhaitez placer sur la page",
			mainPageInfoSubtitle: "Texte complémentaire au titre",
			colorPlaceholder: "Sélectionner la couleur",
			slugDescription:
				"Personnalisez le lien vers votre site de pré-charge. Il ne peut pas contenir d'espaces, de lettres majuscules et de caractères spéciaux (!@#$%ˆ&*(){}[]<>).",
		},
		rechargeSettings: {
			title: "Paramètres de préchargement",
			rechargesLimit: "Limites de precharge",
			rechargesLimitDescription:
				"Établir le montant minimum par precharge et le montant maximum par utilisateur (somme de toutes les precharges prévues pendant la période d'exploitation).",
			minimumValue: "Valeur de precharge minimale",
			maximumValuePerUser:
				"Valeur de precharge maximale par utilisateur (période de fonctionnement)",
			suggestion: "Suggestion de valeur de recharge",
			suggestionDescription:
				"Sur le site de pré-charge, le client peut sélectionner l'une des valeurs déjà proposées ou saisir la valeur qu'il souhaite, en respectant les limites minimales et maximales établies ci-dessus. Proposer 4 valeurs à afficher sur le site. Si vous vous le souhaitez, vous pouvez également offrir à vos clients des bonus basés sur des suggestions de valeur.",
			preSetedValue: "Valeur suggérée",
			bonus: "Bonus gratuit",
			bonusDescription:
				"Si vous le souhaitez, vous pouvez également offrir des cadeaux à vos clients pour gagner des bonus basés sur des suggestions de valeur.",
			paymentMethods: "Modes de paiement",
			paymentMethodsDescription:
				"Choisissez les modes de paiement à accepter. Au moins un d'entre eux doit être sélectionné",
			bonusTable: {
				rechargeValue: "Valeur de precharge",
				bonus: "Bonus",
			},
			addValue: "Ajouter une valeur suggérée au site Web",
			suggestedValue: "Valeurs ajoutées suggérées",
			removeValue: "cliquez sur le X pour supprimer",
			noBonus: "Pas de bonus",
			minimumValueDescription: "La valeur minimale que votre client peut télécharger est",
			maximumValueDescription:
				"La somme de toutes les valeurs de précharge ne peut pas dépasser",
			cardTitle: "Suggestion de préchargement",
			cardBonus: "Bonus gratuit",
			addButton: "Ajouter une valeur suggérée",
			drawerTitle: "Ajouter une suggestion",
			drawerOkButton: "Enregistrer la suggestion",
			radioYes: "Oui. Je souhaite offrir des bonus à mes clients",
			radioNo: "Non. Je ne veux pas offrir de bonus à mes clients",
			bonusExample:
				"En chargeant <span>{{preSetedValue}}</span> votre client recevra un bonus gratuit <span>{{bonus}}</span>.",
		},
		tips: {
			title: "Conseils pour l'événement",
			selectTips: "Section conseils sur le site Web",
			yesOpt: "Oui. Ajouter une section de conseils sur le site Web.",
			noOpt: "Non. Ne pas ajouter de section de conseils sur le site.",
			mainQuestion:
				"Souhaitez-vous insérer une section avec des conseils pour que les clients vivent la meilleure expérience possible lors de votre événement ?",
			importantInfoQuestion:
				"Définissez ci-dessous les informations importantes concernant votre événement, en leur attribuant un titre et un texte qui le complète.",
			tipTitle: "Titre de l'astuce",
			tipTitlePlaceholder: "Ex. : Puis-je transporter de l'eau dans mon sac à dos ?",
			tipDescription: "Texte d'astuce informatif",
			tipDescriptionPlaceholder:
				"Ex. : Vous pouvez transporter de l'eau dans des bouteilles transparentes",
			addMoreTip: "Ajouter plus de conseils",
			deleteTip: "Supprimer le conseil",
			addButton: "Ajouter un conseil",
			drawerOkButton: "Enregistrer l'astuce",
		},
		validations: {
			required: "Champ obligatoire",
			requiredOption: "Sélectionner une option",
			invalidSlugRules: "une ou plusieurs règles n'ont pas été respectées",
			maxValuPerUserLowerThanMinValue:
				"La valeur maximale par utilisateur doit être supérieure à la valeur minimale",
			presetedValueLowerThanMinValue:
				"La valeur de precharge doit être supérieure à la valeur minimale",
			presetedValueHigherThanMaxValuePerUser:
				"La valeur de precharge doit être inférieure à la valeur maximale par utilisateur",
			presetedValueAlreadyExists: "La valeur de precharge existe déjà",
			isTipsEnabled: "Veuillez ajouter un conseil",
			slug: "Slug ne respecte pas les règles ci-dessus",
			rechargesLimitMinimumValue:
				"La valeur minimale par utilisateur doit être inférieure à la valeur maximale",
			presetedValuesLowerThanMinValue:
				"Il existe des valeurs suggérées inférieures à la valeur minimale de recharge",
			presetedValuesHigherThanMaxValue:
				"Il existe des valeurs suggérées supérieures à la valeur de recharge maximale",
			preSetedBonus:
				"La valeur du bonus ne peut pas être supérieure à la valeur de la recharge",
		},
	},
	report: {
		precharge: "Précharge",
		edit: "Modifier le site",
		showSite: "Voir le site",
		costumersTitle: "{{value}} personnes",
		costumersDescription: "Ils ont préchargé",
		ticketsDescription: "Billet moyen",
		collectedDescription: "Montant collecté",
		redeemedDescription: "Valeur échangée",
		maleTitle: "{{value}} hommes",
		femaleTitle: "{{value}} femmes",
		otherTitle: "{{value}} autres",
		paymentMethod: "Méthode de paiement",
		value: "Valeur",
		prechargePerDay: "Précharges par jour",
		date: "Date",
		dateHour: "Date/Heure",
		name: "Nom",
		document: "Document",
		email: "Email",
		bonus: "Bonus",
		cardSymmary: "Carte utilisée",
		cardBrand: "Drapeau de carte",
		isUsed: "Sauvé?",
		filter: {
			name: "Nom du client",
			document: "Document",
			email: "Email",
			acquirerTransactionId: "Transaction de l'acquéreur",
			paymentMethod: "Mode de paiement",
			status: "Statut",
		},
		creditCard: "Carte de crédit",
		pix: "PIX",
		billing: "Facturation",
		total: "Total",
		rescuedValue: "Valeur sauvée",
		residual: "Résiduel",
		status: {
			pendingReview: "En attente",
			refunded: "Remboursé",
			refused: "Refusé",
			success: "Approuvé",
		},
		errors: {
			hasWhitespace: "Ne peut pas contenir d'espaces",
			hasUpperCase: "Ne peut pas contenir de lettres majuscules",
			hasSpecialCharacter: "Ne peut pas contenir de caractères spéciaux",
			acquirerTransactionIdError: "Veuillez entrer un identifiant valide",
			documentError: "Veuillez entrer un document valide",
		},
	},
};
